export default __webpack_public_path__ + "static/media/1_3.f1a4b4ef.png";